import { url, locale } from 'utils'

const mapLang = {
  fr: 'fr-FR',
  en: 'en-GB',
}

export const load = (action, store, { window, http }) => {
  const { navigator } = window
  let lang = 'fr-FR'
  if (navigator) {
    const { language, userLanguage, languages } = navigator
    lang = language || userLanguage || (languages && languages.length > 0 && languages[0]) || 'en-GB'
    lang = mapLang[lang.substring(0, 2)] || 'en-GB'
  }

  locale.set(store, lang)
  return http('LOCALES').get(url.appendVersion(`/locales/${lang}.json`))
}

export const set = ({ payload }, store) => store.config.locale.set(payload)
